<form *ngIf="fields && render.form" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="form" (submit)="save()">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'reason.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'reason.edit_title' | translate}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button class="k-generic-btn" pButton type="button" routerLink="/loyalty/reason" icon="fa fa-arrow-left" iconPos="left" label="{{ 'common.back' | translate }}"></button>
        <button class="k-generic-btn" pButton type="submit" icon="fa fa-floppy-o" iconPos="left" label="Save"></button>
      </div>
    </div>
    <div class="card Customers">

      <div class="ui-g">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.sign_pid.nullable}">{{ fields.sign_pid.keyName }}</span>
          <p-dropdown [options]="paramsSign" formControlName="sign_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.sign_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.type_pid.nullable}">{{ fields.type_pid.keyName }}</span>
          <p-dropdown [options]="paramsType" formControlName="type_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.type_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.reason_code.nullable}">{{ fields.reason_code.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="reason_code"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.reason_code"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-10 ui-md-6">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.description"></app-validation-msg>
        </div>

        <div class="ui-g-10 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.short_description.nullable}">{{ fields.short_description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="short_description" maxlength="30"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.short_description"></app-validation-msg>
        </div>
      </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reason/form-reason-loyalty/form-reason-loyalty.component.html